import api from './api';

export const BoatService = {
    getBoats() {
        return api().get('/products/featured');
    },
    /**
     * @param {number|string} boatId
     * @param {string} query
     */
    getDisabledDates(boatId, query) {
        return api().get(`/order/disable-dates/${boatId}?${query}`);
    }
}
